import { DotGroup } from 'pure-react-carousel';
import React from 'react';
import styled from 'styled-components';
import THEME from '../../styles/colors';
import { StyledCardFooter } from '../Card/StyledCardFooter';

const StyledCarouselDotGroup = styled.div`
  & .carousel__dot-group {
    display: flex;
    align-items: center;
    justify-content: center;

    & .carousel__dot {
      padding: 12px 2px;
      margin: 0 4px;
      background-color: transparent;
      appearance: none !important;
      > span {
        display: block;
        width: 15px;
        height: 4px;
        background-color: ${THEME.surface.secondary} !important; // For iOS
        border-radius: 5px;
      }
    }
    & .carousel__dot--selected > span {
      background-color: ${THEME.other.link} !important;
    }
  }
`;

const CarouselIndicator = () => (
  <StyledCarouselDotGroup>
    <DotGroup />
  </StyledCarouselDotGroup>
);

const StyledCarouselIndicatorCardFooter = styled(StyledCardFooter)`
  padding: 4px 0;
`;

export const CarouselIndicatorCardFooter = () => (
  <StyledCarouselIndicatorCardFooter>
    <CarouselIndicator />
  </StyledCarouselIndicatorCardFooter>
);

export default CarouselIndicator;
